import { useParams } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import useFetch from "../useFetch";
import { useState } from "react";

const HindiBksRead = () => {
    const {id} = useParams();
    const regex = /\*\*/g;
    const [nightMode,setNightmode] = useState(false);
    
    const {data: books, ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/HindiBooks/`+ id);

    return (
   <div className={`blog-details ${nightMode? 'nightmode':'normal'}`}>
              {erroralert && <div> {erroralert}</div>}
            {ispending && <div style={{marginTop: "2rem"}}> 
            <CircularProgress color="secondary"/> <br/>
            Preparing Book...
            </div>} 

            {!ispending && !nightMode && <button id="toggleButton" onClick={() => {setNightmode(!nightMode)}}>रात में पढ़ना</button>}
        {nightMode && <button id="toggleButton" onClick={() => {setNightmode(!nightMode)}} style={{
            backgroundColor: "#ddd",
            color: "black"
        }}>सामान्य पर स्विच करें</button>}
          
            {books && (
                <article>
                  <h2>{books.title}</h2>
                  <h3> {books.author} द्वारा लिखित </h3>
                  <img src={books.image} alt="book cover"></img>
                  <p>{books.body.replace(regex,"\n\n")}</p>
            
                </article>
            )}
        </div>
      );
}
 
export default HindiBksRead;